/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Menu(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <rect
                        fill='none'
                        height='26'
                        id='canvas_background'
                        width='26'
                        x='-1'
                        y='-1'
                    />
                </g>
                <g
                    fill={iconColor || '#000'}
                    id='svg_5'
                    stroke='null'
                >
                    <path
                        d='m0.600289,23.237996l22.651841,0l0,-3.751526l-22.651841,0l0,3.751526zm0,-9.378111l22.651841,0l0,-3.751526l-22.651841,0l0,3.751526zm0,-13.12823l0,3.751526l22.651841,0l0,-3.751526l-22.651841,0z'
                        id='svg_1'
                        stroke='null'
                    />
                </g>
            </svg>
        </SvgIcon>
    );
}